export enum InviteeType {
  Group = 0,
  Individual = 1
}
